import { Component, OnInit, TemplateRef } from '@angular/core';
import { Location, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { proposalData } from './motor-proposal-data-modal';
// import { motorProposalData } from './motor-proposal-data.model'
import { ToasterService } from '../services/toaster.service';
import { environment } from '../../environments/environment';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
// import * as jsondata from 'https://securenow-calculators.s3.ap-south-1.amazonaws.com/Motor-Insurance/PincodeGoDigitSortedA.json';

@Component({
  selector: 'app-motor-insurance',
  templateUrl: './motor-insurance.component.html',
  styleUrls: ['./motor-insurance.component.css'],
  providers: [ToasterService]
})
export class MotorInsuranceComponent implements OnInit {
  f: proposalData = new proposalData();
  // proposalForm: motorProposalData = new motorProposalData();
  modalRef: BsModalRef;
  activeTab: string = 'details';
  data: any = {};
  newdata: any = {};
  error: any;
  manufacturerList: {}[];
  vehicleList: {}[];
  stateList: {}[];
  manufacturerCode: string[];
  selectedOption: any;
  manufaturerMap: { 'key': string; 'value': {}; };
  listOfManufacturer: any[];
  selectedKeyValue: any;
  loading: boolean;
  stateMap: { 'key': string; 'value': {}; };
  listOfStates: any[];
  rtoCityList: {}[];
  selectedStateValue: any;
  vehicleKey: {}[];
  masterVehicleList: {}[];
  vehicleMap: { 'key': string; 'value': {}; };
  listOfVehicle: any[];
  selectedModelKeyValue: any;
  selectedStateKey: any;
  selectedCityValue: any;
  cityMap: { 'key': string; 'value': {}; };
  listOfCity: any[];
  userID: string;
  typeOptions: string = "New Business";
  selectedModelOption: any;
  selectedCityKey: any;
  city: any;
  state: any;
  quotesDetailsTable: boolean;
  motorProposalPageHdfc: boolean;
  motorProposalPageGodigit: boolean;
  selectedManufaturerCode: string;
  regDate: Date;
  hdfcPremium: any;
  idvRange: any;
  goDigitPremium: any;
  notAvailable: boolean;
  goDigitNotAvailable: boolean;
  electricalHdfcBasic: string = "0";
  nonElectricalHdfcBasic: string = "0";
  hdfcCngLpgBasic: string = "0";
  electricalHdfcEssential: string = "0";
  nonElectricalHdfcEssential: string = "0";
  hdfcCngLpgEssential: string = "0";
  electricalHdfcComprehensive: string = "0";
  nonElectricalHdfcComprehensive: string = "0";
  hdfcCngLpgComprehensive: string = "0";
  

  roi0: string = "1";
  roi1: string = "1";
  ncb1: string = "1";
  engine0: string = "1";
  engine1: string = "1";
  roadSideAssistance0: string = "1";
  roadSideAssistance1: string = "1";
  consumable0: string = "1";
  consumable1: string = "1";
  rimDamage: string = "1";
  keyReplacement: string = "1";
  tyreCover: string = "1";

  electricalGoDigitBasic: string = "0";
  nonElectricalGoDigitBasic: string = "0";
  goDigitCngLpgBasic: string = "0";
  electricalGoDigitEssential: string = "0";
  nonElectricalGoDigitEssential: string = "0";
  goDigitCngLpgEssential: string = "0";
  electricalGoDigitComprehensive: string = "0";
  nonElectricalGoDigitComprehensive: string = "0";
  goDigitCngLpgComprehensive: string = "0";

  vehicleRtoCode: string;
  cityStateList: any;
  cityList: any;
  stateFirst: any[];
  invalidPincode: boolean;
  manufaturingDate: Date;
  fuel: string;
  area: string;
  otpVerified: boolean;
  otp: string;
  verifyOtpBtn: boolean;
  hdfcOtp: string;
  citySelected: string;
  motorQuoteId: number;
  proposalDob: string;
  selectedOccupation: string;
  typeOptionsSection: boolean;
  selectedModelName: string;
  public environment = environment;
  totalPremiumForHdfc: string;
  insurerValue: string = "godigit";
  totalPremiumForGoDigit: string;
  currentDate: Date;
  txnId: string;
  transactionNo: string;
  hdfcThankyouSection: boolean;
  hdfcTransactionFailureSection: boolean;
  godigitThankyouSection: boolean;
  godigitTransactionFailureSection: boolean;
  goDigitVehicleCode: string;
  goDigitIdvRange: any;
  hdfcData: any;
  goDigitData: any;
  month1: any;
  areaList: {}[];
  totalPremiumIncludedTaxGoDigit: string;
  goDigitServiceTax: string;
  hdfcFirstData: any;
  loadingGodigit: boolean;

  policyStartDate: any;
  purchaseRegnDate: any;
  prePolicyStartDate: string = "01/01/1990";
  prePolicyEndDate: string;
  manufacturingYear: any;
  isPreviousClaim: string = "0";
  isPreviousDiscount: string = "0";
  claimOpt: string = "0";
  previousDiscount: string = "20";
  // subInsurance: string;
  previousInsurerData: any;
  previousInsurerCode: string;
  newBusinessType: boolean = true;


  premiumOption: String;

  electricalAcc: string;
  nonElectricalAcc: string;
  lpgCng: string;
  zeroDepreciation: string;
  isrtiCovered: string;
  isNcbProtection: string;
  isEngineProtection: string;
  roadSideAssistance: string;
  isCostOfConsumable: string;
  isRimDamageCover: string;
  isTyreCover: string;
  pincodeFirst: string;
  subInsuranceOnLead: any;
  engineNumberLead: any;
  chasisNumberLead: any;
  vehicleRegNumLead: string;
  manufaturingDateLead: any;
  purchaseDateLead: any;
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(private httpClient: HttpClient, private router: Router, private _location: Location, private serviceURLService: serviceURLService, public datepipe: DatePipe, public toasterService: ToasterService, private modalService: BsModalService) {
    this.userID = localStorage.getItem('userID');
  }

  ngOnInit() {
    this.getManufacturer();
    this.getState();
    this.getAutopopulatedData();
    this.getModifiedDate(new Date(), 1, 1, 0);
  }

  getManufacturer() {
    this.loading = true;
    this.serviceURLService.getManufacturerList().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      var masterManufacturerList = Object.values(successData.data)
      this.loading = false;
      let newMafacturingList = [];

      for (let i = 0; i < (masterManufacturerList).length; i++) {
        this.manufaturerMap = {
          'key': Object.keys(successData.data)[i],
          'value': Object.values(successData.data)[i]
        }
        newMafacturingList.push(this.manufaturerMap)
      }

      this.listOfManufacturer = newMafacturingList;

      // this.manufacturerList = Object.values(successData.response.mastersMap);
      this.manufacturerCode = Object.keys(successData.data)
    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  getKeyforManufaturer(event) {
    this.loading = true;
    var listOfBrands = this.manufacturerList

    const selectedManufaturer = event.target;
    this.selectedKeyValue = selectedManufaturer.options[selectedManufaturer.selectedIndex].getAttribute('key');
    this.selectedManufaturerCode = selectedManufaturer.options[selectedManufaturer.selectedIndex].getAttribute('value');
    // console.log("selectedKeyValue ",this.selectedKeyValue);
    // console.log("selectedManufaturerCode ",this.selectedManufaturerCode);
    this.getVehicleModel();
  }

  getKeyforModel(event) {
    //this.loading = true;
    //var listOfBrands = this.manufacturerList

    const selectedModel = event.target;
    this.selectedModelKeyValue = selectedModel.options[selectedModel.selectedIndex].getAttribute('key');
    this.selectedModelName = selectedModel.options[selectedModel.selectedIndex].getAttribute('value');
    // console.log("selectedModelKeyValue ",this.selectedModelKeyValue)
    // console.log("selectedModelName ",this.selectedModelName)
    this.getGoDigitVehicleCode(this.selectedModelKeyValue);
  }

  getVehicleModel() {
    this.serviceURLService.getVehileModelList(this.selectedKeyValue).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      //this.loading = false;
      var masterVehicleList = Object.values(successData.data);
      //this.vehicleKey = Object.keys(successData.response.dataMap)

      let newVehicleList = [];

      for (let i = 0; i < (masterVehicleList).length; i++) {
        this.vehicleMap = {
          'key': Object.keys(successData.data)[i],
          'value': Object.values(successData.data)[i]
        }
        newVehicleList.push(this.vehicleMap)
      }

      this.listOfVehicle = newVehicleList;

      //console.log("vehice ",this.listOfVehicle)
      this.loading = false;
    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }


  getState() {
    this.serviceURLService.getStateList().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      //console.log("location ",successData.response.mastersMap)
      //this.stateList = Object.values(successData.response.mastersMap);
      var masterStateList = Object.values(successData.data)

      let newStateList = [];

      for (let i = 0; i < (masterStateList).length; i++) {
        this.stateMap = {
          'key': Object.keys(successData.data)[i],
          'value': Object.values(successData.data)[i]
        }
        newStateList.push(this.stateMap)
      }

      this.listOfStates = newStateList;
    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }


  getKeyforStates(event) {
    this.loading = true;

    const selectedStates = event.target;
    this.selectedStateKey = selectedStates.options[selectedStates.selectedIndex].getAttribute('key');
    this.selectedStateValue = selectedStates.options[selectedStates.selectedIndex].getAttribute('value');
    //console.log("selectedStateValue ",this.selectedStateValue)
    this.getRtoCity();
  }

  getRtoCity() {
    this.serviceURLService.getRtoCityList(this.selectedStateKey).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      //this.rtoCityList = Object.values(successData.response.dataMap);

      var masterCityList = Object.values(successData.data)

      let newCityList = [];

      for (let i = 0; i < (masterCityList).length; i++) {
        this.cityMap = {
          'key': Object.keys(successData.data)[i],
          'value': Object.values(successData.data)[i]
        }
        newCityList.push(this.cityMap)
      }

      this.listOfCity = newCityList;
      // console.log(this.listOfCity)
      this.city = this.listOfCity[0];
      this.loading = false;
    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  getSelectedCity(event) {
    const selectedCity = event.target;
    this.selectedCityKey = selectedCity.options[selectedCity.selectedIndex].getAttribute('key');
    this.selectedCityValue = selectedCity.options[selectedCity.selectedIndex].getAttribute('value');
    //console.log("selectedCityValue ",this.selectedCityValue)
    this.getRtoAgency();
  }

  getRtoAgency() {
    this.loading = true;
    this.serviceURLService.getRtoAgency().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      var rtoData = successData.data
      for (let i = 0; i < rtoData.length; i++) {
        var rtoDataList = Object.values(rtoData)[i];
        let rtoDataCityCode = Object.values(rtoDataList)[4];
        let rtoDataState = Object.values(rtoDataList)[2];

        if (rtoDataCityCode == this.selectedCityKey) {
          let rtoVehicleNum = Object.values(rtoData)[i];
          //  console.log("rtoVehicleNum",Object.values(rtoVehicleNum)[3]);
          this.vehicleRtoCode = Object.values(rtoVehicleNum)[3];
        }
      }

      this.loading = false;
    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }
  // To get GoDigit vehicle Code
  getGoDigitVehicleCode(key) {
    // console.log("selectedCarKey ",key)
    this.loading = true;
    const vehicleCode = {
      "XLEW_2_4_5": JSON.parse(key)
    }
    this.serviceURLService.getGoDigitVehicleCode(vehicleCode).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.goDigitVehicleCode = successData.XLEW_2_6_5;
      this.loading = false;
    }, errorData => {
      console.log("Oops..!! there is some error in getting Godigit Vehicle Code");
      if (errorData) {
        this.error = errorData.error.message;
      }
    })
  }


  submitDetailsforProd() {
    this.loading = true;
    var typeSelected = (<HTMLInputElement>document.querySelector('input[name="typeOptions"]:checked')).value;
    var citySelected = (<HTMLInputElement>document.getElementById("city")).value;
    // console.log("type ",typeSelected);
    // console.log("selected key",this.selectedKeyValue);
    // console.log("selected state ",this.selectedStateValue);
    //console.log("selected City ",citySelected)
    //var sumInsured = document.querySelector('input[name="optradio"]:checked').value;
    var prospectId = localStorage.getItem('prospectIdMotor'); var hostname = window.location.hostname;
    if( hostname == "staging.securenow.app"  || hostname == "localhost"){
      window.location.replace("https://pamstaging.securenow.in/individual-insurance/motor-insurance?isAmp=true&prospectId="+prospectId+"&businessType="+typeSelected+"&manufacturer-name="+this.selectedKeyValue+"&vehicle-model="+this.selectedModelKeyValue+"&purchase-location="+this.selectedStateKey+"&purchase-city="+this.selectedCityKey);
    }else if(hostname == "securenow.app"){
    window.location.replace("https://securenow.in/individual-insurance/motor-insurance?isAmp=true&prospectId=" + prospectId + "&businessType=" + typeSelected + "&manufacturer-name=" + this.selectedKeyValue + "&vehicle-model=" + this.selectedModelKeyValue + "&purchase-location=" + this.selectedStateKey + "&purchase-city=" + this.selectedCityKey);
    }
  }

  //  ....................  To Get Quotation Details  ...................
  submitDetails() {
    this.loading = true;
    this.loadingGodigit = true;
    var typeSelected = (<HTMLInputElement>document.querySelector('input[name="typeOptions"]:checked')).value;
    this.citySelected = (<HTMLInputElement>document.getElementById("city")).value;
    if (this.regDate) {
      var vehicleRegistrationDate = this.datepipe.transform(this.regDate, 'dd/MM/yyyy');
    } else {
      vehicleRegistrationDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    }
    let todaysDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    // console.log("regDate ",vehicleRegistrationDate);

    // console.log("type ",typeSelected);
    // console.log("selected key",this.selectedKeyValue);
    // console.log("selected state ",this.selectedStateValue);
    //console.log("selected City ",citySelected)
    //var sumInsured = document.querySelector('input[name="optradio"]:checked').value;

    // var prospectId = localStorage.getItem('prospectIdMotor');var hostname = window.location.hostname;
    // if( hostname == "staging.securenow.app"  || hostname == "localhost"){
    //   window.location.replace("https://pamstaging.securenow.in/individual-insurance/motor-insurance?isAmp=true&prospectId="+prospectId+"&businessType="+typeSelected+"&manufacturer-name="+this.selectedKeyValue+"&vehicle-model="+this.selectedModelKeyValue+"&purchase-location="+this.selectedStateKey+"&purchase-city="+this.selectedCityKey);
    // }else if(hostname == "securenow.app"){
    //   window.location.replace("https://securenow.in/individual-insurance/motor-insurance?isAmp=true&prospectId="+prospectId+"&businessType="+typeSelected+"&manufacturer-name="+this.selectedKeyValue+"&vehicle-model="+this.selectedModelKeyValue+"&purchase-location="+this.selectedStateKey+"&purchase-city="+this.selectedCityKey);      
    // }

    this.manufaturingDateLead = this.datepipe.transform(this.manufaturingDateLead, 'dd/MM/yyyy');
    this.purchaseDateLead = this.datepipe.transform(this.purchaseDateLead, 'dd/MM/yyyy');
    // var from = this.manufaturingDateLead.split("/")[2];
    // var mydate = new Date(from[2], from[1] - 1, from[0]);
    // this.manufaturingDateLead = this.manufaturingDateLead.split("/")[2];
    console.log(this.manufaturingDateLead);

    this.data = {
      businessType: this.typeOptions,
      manufacturerCode: this.selectedKeyValue,
      vehicleModel: this.selectedModelKeyValue,
      stateCode: this.selectedStateKey,
      purchaseCity: this.selectedCityKey,
      // purchaseRegnDate: this.purchaseRegnDate,
      isPreviousClaim: this.claimOpt,
      isPreviousDiscount: this.isPreviousDiscount,
      policyStartDate: this.policyStartDate,
      prePolicyStartDate: this.prePolicyStartDate,
      prePolicyEndDate: this.prePolicyEndDate,
      // manufacturingYear: JSON.stringify(this.manufacturingYear),
      manufacturingYear: this.getDefaultManufacturingYear(this.manufaturingDateLead),
      manufacturingDate: this.manufaturingDateLead,
      purchaseRegnDate: this.purchaseDateLead,
      policyEndDate: this.getModifiedDate(todaysDate, 1, -1, 0),
      age: "Up to 35",
      electricalAcc: false,
      nonElectricalAcc: false,
      lpgCng: false,
      manufacturer: this.selectedManufaturerCode,
      vehicleModelName: this.selectedModelName,
      state: this.selectedStateValue,
      purchaseCityName: this.selectedCityValue,
      quoteId: "",
      prospectId: localStorage.getItem("prospectIdMotor"),
      // prospectId: "447697",
      goDigitVehicleModel: JSON.stringify(this.goDigitVehicleCode),
      // vehicleRegnNo: this.vehicleRtoCode + "AB1234",
      vehicleRegnNo: this.vehicleRegNumLead,
      engineNo: this.engineNumberLead,
      chassisNo: this.chasisNumberLead,
      sumInsured: "0",
      isrtiCovered: true,
      roadSideAssistance: true,
      zeroDepreciation: true,
      isEngineProtection: true,
      isCostOfConsumable: true,
      isTyreCover: true,
      isRimDamageCover: true,
      subInsuranceProductCode: this.subInsuranceOnLead,
      pincode: this.pincodeFirst,
      partsDepreciation: true,
      returnToInvoice: true
    }
    // ................  To get GoDigit Quote Details  ......................
    this.serviceURLService.motorComparePremium(this.data, "godigit").pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // console.log("successData goDigit ",successData);

      this.quotesDetailsTable = true;
      this.loadingGodigit = true;
      this.goDigitData = successData.data;
      this.goDigitPremium = successData.data.goDigitPremium;
      if (this.goDigitPremium.option0 == null || this.goDigitPremium.option1 == null || this.goDigitPremium.option2 == null) {
        this.goDigitNotAvailable = true;
      } else {
        this.goDigitNotAvailable = false;
      }

      this.goDigitIdvRange = successData.data.idvRange;

      this.saveQuoteDetails("godigit", this.premiumOption);
      // this.rtoCityList = Object.values(successData.response.dataMap);
      this.loadingGodigit = false;

    }, errorData => {

      console.log("Oops..!! there is something wrong in Go Digit Compare Premium");
      this.loadingGodigit = false;
      this.loading = false;
      if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        this.quotesDetailsTable = true;
        this.notAvailable = true;
        this.loadingGodigit = false;
        // this.goDigitPremium ={
        //   option0: "20000",
        //   option1: "21000",
        //   option2: "22000"
        // }
        //this.saveQuoteDetails("godigit");
      }
    })

    // -------------- Uncomment for Enable HDFC -----------------
    // ...............   To get HDFC Quote Details    ...................
    // this.serviceURLService.motorComparePremium(this.data,"hdfc").subscribe((successData:any) => {
    //   console.log("successData hdfc ",successData);
    //   this.quotesDetailsTable = true;
    //   this.hdfcData = successData.data;
    //   this.hdfcFirstData = successData.data;
    //   this.hdfcPremium = successData.data.hdfcPremium;
    //   if(successData.data == null || this.hdfcPremium.option0 == null || this.hdfcPremium.option1 == null || this.hdfcPremium.option2 == null){
    //     this.notAvailable = true;
    //   }else{
    //     this.notAvailable = false;
    //   }
    //   this.idvRange = successData.data.idvRange;
    //   this.loading = false;
    //   // this.rtoCityList = Object.values(successData.response.dataMap);
    //   this.saveQuoteDetails("hdfc");
    // }, errorData => {
    //   console.log("Oops..!! there is something wrong in HDFC Compare Premium");
    //   this.loading = false;
    //   if(errorData.error.status === 403 || errorData.error.status === 400){
    //     this.error = errorData.error.message;
    //     this.quotesDetailsTable = true;
    //     this.notAvailable = true;
    //     this.loading = false;
    //   }
    // })


  }

  //  ............. To Save Quote Details ....................
  saveQuoteDetails(insurer, selectedOptionValue) {
    // this.loading = true;
    // var citySelected = (<HTMLInputElement>document.getElementById("city")).value;
    if (this.regDate) {
      var vehicleRegistrationDate = this.datepipe.transform(this.regDate, 'dd/MM/yyyy');
    } else {
      vehicleRegistrationDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    }
    let todaysDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    console.log(insurer);
    // console.log(selectedOptionValue);
    this.premiumOption = selectedOptionValue;
    // for motor Add On covers
    if (this.premiumOption == "0") {
      // this.electricalAcc = "1";
      // this.nonElectricalAcc = "1";
      // this.lpgCng = "1";
      this.zeroDepreciation = "1";   //Parts Depreciation Cover
      // this.isNcbProtection = "1";
      this.isEngineProtection = "1"; //Engine And Gear Box ProtectionCover
      this.isCostOfConsumable = "1"; //Consumable Cover
      this.roadSideAssistance = "1"; //Breakdown Assistance Cover
      this.isrtiCovered = "1";       //Return To Invoice Cover
      this.isRimDamageCover = "1";   //Rim Damage Cover
      this.isTyreCover = "1";        //Tyre Protect Cover
    } else if (this.premiumOption == "1") {
      this.zeroDepreciation = "1";   //Parts Depreciation Cover
      // this.isNcbProtection = "1";
      this.isEngineProtection = "1"; //Engine And Gear Box ProtectionCover
      this.isCostOfConsumable = "1"; //Consumable Cover
      this.roadSideAssistance = "1"; //Breakdown Assistance Cover
      this.isrtiCovered = "0";       //Return To Invoice Cover
      this.isRimDamageCover = "0";   //Rim Damage Cover
      this.isTyreCover = "0";        //Tyre Protect Cover
    } else if (this.premiumOption == "2") {
      this.zeroDepreciation = "0";   //Parts Depreciation Cover
      // this.isNcbProtection = "1";
      this.isEngineProtection = "0"; //Engine And Gear Box ProtectionCover
      this.isCostOfConsumable = "0"; //Consumable Cover
      this.roadSideAssistance = "0"; //Breakdown Assistance Cover
      this.isrtiCovered = "0";       //Return To Invoice Cover
      this.isRimDamageCover = "0";   //Rim Damage Cover
      this.isTyreCover = "0";        //Tyre Protect Cover
    }

    if (insurer == "hdfc") {
      this.data = {
        company: "",
        location: this.citySelected,
        mobile: localStorage.getItem("mobileNumber"),
        email: localStorage.getItem("email"),
        couponCode: "",
        businessType: this.typeOptions,
        manufacturerCode: this.selectedKeyValue,
        vehicleModel: this.selectedModelKeyValue,
        stateCode: this.selectedStateKey,
        purchaseCity: this.selectedCityKey,
        purchaseRegnDate: this.purchaseRegnDate,
        isPreviousClaim: this.claimOpt,
        isPreviousDiscount: this.isPreviousDiscount,
        policyStartDate: this.policyStartDate,
        prePolicyStartDate: this.prePolicyStartDate,
        prePolicyEndDate: this.prePolicyEndDate,
        manufacturingYear: JSON.stringify(this.manufacturingYear),
        policyEndDate: this.getModifiedDate(todaysDate, 1, -1, 0),
        age: "Up to 35",
        electricalAcc: "0",
        nonElectricalAcc: "0",
        lpgCng: "0",
        manufacturer: this.selectedManufaturerCode,
        vehicleModelName: this.selectedModelName,
        state: this.selectedStateValue,
        purchaseCityName: this.selectedCityValue,
        quoteId: "",
        prospectId: localStorage.getItem("prospectIdMotor"),
        // prospectId: "447697",
        goDigitVehicleModel: JSON.stringify(this.goDigitVehicleCode),
        vehicleRegnNo: this.vehicleRtoCode + "AB1234",
        sumInsured: this.idvRange.sumInsured,
        exshowRoomPrice: this.idvRange.exShowRoomPrice,
        totalIDV1: this.idvRange.minSumInsured,
        totalIDV2: this.idvRange.minSumInsured,
        totalIDV3: this.idvRange.minSumInsured,
        premium1: this.hdfcPremium.option0,
        premium2: this.hdfcPremium.option1,
        premium3: this.hdfcPremium.option2,
        electrical1: this.electricalHdfcBasic,
        electrical2: this.electricalHdfcEssential,
        electrical3: this.electricalHdfcComprehensive,
        nonElectrical1: this.nonElectricalHdfcBasic,
        nonElectrical2: this.nonElectricalHdfcEssential,
        nonElectrical3: this.nonElectricalHdfcComprehensive,
        cngLpg1: this.hdfcCngLpgBasic,
        cngLpg2: this.hdfcCngLpgEssential,
        cngLpg3: this.hdfcCngLpgComprehensive,
        manufacturingDate: this.manufaturingDateLead,
        zeroDepreciation1: "0",
        zeroDepreciation2: "1",
        zeroDepreciation3: "1",
        rti1: this.roi1,
        rti2: "0",
        rti3: "0",
        "ncb1": this.ncb1,
        "ncb2": "0",
        "ncb3": "0",
        "isConsumable1": this.consumable1,
        "isConsumable2": "0",
        "isConsumable3": "0",
        "keyReplacement1": this.keyReplacement,
        "keyReplacement2": "0",
        "keyReplacement3": "0",
        "roadSideAssistance1": this.roadSideAssistance1,
        "roadSideAssistance2": "0",
        "roadSideAssistance3": "0",
        "engineProtection1": this.engine1,
        "engineProtection2": "0",
        "engineProtection3": "0",
        "insurer1": "hdfc",
        "insurer2": "hdfc",
        "insurer3": "hdfc",
        "isTyre1": this.tyreCover,
        "isTyre2": "0",
        "isTyre3": "0",
        "isRimDamage1": this.rimDamage,
        "isRimDamage2": "0",
        "isRimDamage3": "0",
        "isPaUnnamedPassenger1": "1",
        "isPaUnnamedPassenger2": "1",
        "isPaUnnamedPassenger3": "1",
      }
    } else {
      this.data = {
        company: "",
        location: this.citySelected,
        mobile: localStorage.getItem("mobileNumber"),
        email: localStorage.getItem("email"),
        couponCode: "",
        businessType: this.typeOptions,
        manufacturerCode: this.selectedKeyValue,
        vehicleModel: this.selectedModelKeyValue,
        stateCode: this.selectedStateKey,
        purchaseCity: this.selectedCityKey,
        purchaseRegnDate: this.purchaseRegnDate,
        isPreviousClaim: this.claimOpt,
        isPreviousDiscount: this.isPreviousDiscount,
        policyStartDate: this.policyStartDate,
        prePolicyStartDate: this.prePolicyStartDate,
        prePolicyEndDate: this.prePolicyEndDate,
        manufacturingYear: JSON.stringify(this.manufacturingYear),
        policyEndDate: this.getModifiedDate(todaysDate, 1, -1, 0),
        age: "Up to 35",
        electricalAcc: "0",
        nonElectricalAcc: "0",
        lpgCng: "0",
        manufacturer: this.selectedManufaturerCode,
        vehicleModelName: this.selectedModelName,
        state: this.selectedStateValue,
        purchaseCityName: this.selectedCityValue,
        quoteId: "",
        prospectId: localStorage.getItem("prospectIdMotor"),
        // prospectId: "447697",
        goDigitVehicleModel: JSON.stringify(this.goDigitVehicleCode),
        vehicleRegnNo: this.vehicleRegNumLead,
        sumInsured: this.goDigitIdvRange.sumInsured,
        exshowRoomPrice: this.goDigitIdvRange.exShowRoomPrice,

        zeroDepreciation: this.zeroDepreciation,
        isrtiCovered: this.isrtiCovered,
        isNcbProtection: this.isNcbProtection,
        isEngineProtection: this.isEngineProtection,
        roadSideAssistance: this.roadSideAssistance,
        isCostOfConsumable: this.isCostOfConsumable,
        isRimDamageCover: this.isRimDamageCover,
        isTyreCover: this.isTyreCover,
        manufacturingDate: this.manufaturingDateLead,

        "zeroDepreciation1": "1",
        "zeroDepreciation2": "1",
        "zeroDepreciation3": "1",
        "totalIDV1": this.goDigitIdvRange.maxSumInsured,
        "totalIDV2": this.goDigitIdvRange.sumInsured,
        "totalIDV3": this.goDigitIdvRange.minSumInsured,
        "roadSideAssistance1": "1",
        "roadSideAssistance2": "1",
        "roadSideAssistance3": "0",
        "rti1": "1",
        "rti2": "0",
        "rti3": "0",

        "premium1": this.goDigitPremium.option0,
        "premium2": this.goDigitPremium.option1,
        "premium3": this.goDigitPremium.option2,


        "ncb1": "1",
        "ncb2": "0",
        "ncb3": "0",
        "nonElectrical1": "0",
        "nonElectrical2": "0",
        "nonElectrical3": "0",

        "insurer1": "goDigit",
        "insurer2": "goDigit",
        "insurer3": "goDigit",
        "isConsumable1": "1",
        "isConsumable2": "1",
        "isConsumable3": "0",
        "isPaUnnamedPassenger1": "1",
        "isPaUnnamedPassenger2": "1",
        "isPaUnnamedPassenger3": "1",
        "isRimDamage1": "1",
        "isRimDamage2": "0",
        "isRimDamage3": "0",
        "isTyre1": "1",
        "isTyre2": "0",
        "isTyre3": "0",
        "engineProtection1": "1",
        "engineProtection2": "1",
        "engineProtection3": "0",
        "electrical1": "0",
        "electrical2": "0",
        "electrical3": "0",
        "cngLpg1": "0",
        "cngLpg2": "0",
        "cngLpg3": "0",

      }
    }

    this.serviceURLService.saveMotorQuoteDetails(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // console.log("successData Save details ",successData);
      // this.quotesDetailsTable = true;
      this.motorQuoteId = successData.data.quoteId;
      this.loading = false;
      this.loadingGodigit = false
    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })

  }

  goToProposal(selectedinsurer, selectedOptionValue) {
    console.log(selectedOptionValue);
    this.premiumOption = selectedOptionValue;
    // console.log("proposal insurer Buy now Click",selectedinsurer)
    // ---------------Using only for single insurer case start--------------------
    if (this.goDigitData == null || this.goDigitPremium.option0 == null || this.goDigitPremium.option1 == null || this.goDigitPremium.option2 == null) {
      // this.modalService.show("thankYou"); 
      this.toasterService.showErrorToaster("Thank You, we will call you back in 24 hours.");
    } else {
      this.quotesDetailsTable = false;
      // if(insurer == "godigitInsurer1" || insurer == "godigitInsurer2" || insurer == "godigitInsurer3"){
      this.motorProposalPageGodigit = true;
      this.motorProposalPageHdfc = false;
      this.saveQuoteDetails("godigit", selectedOptionValue);
      this.getAutopopulatedData();
      // }
    }
    // ---------------Using only for single insurer case end--------------------

    if (selectedinsurer == "hdfc") {
      if (this.hdfcData == null || this.hdfcPremium.option0 == null || this.hdfcPremium.option1 == null || this.hdfcPremium.option2 == null) {
        // this.modalService.show("thankYou"); 
        this.toasterService.showErrorToaster("Thank You, we will call you back in 24 hours.");
      } else {
        this.quotesDetailsTable = false;
        // if(insurer == "hdfcInsurer1" || insurer == "hdfcInsurer2" || insurer == "hdfcInsurer3"){
        this.motorProposalPageHdfc = true;
        this.motorProposalPageGodigit = false;
        this.saveQuoteDetails("hdfc", this.premiumOption);
        this.getAutopopulatedData();
        // }
      }
    } else if (selectedinsurer == "goDigit") {
      if (this.goDigitData == null || this.goDigitPremium.option0 == null || this.goDigitPremium.option1 == null || this.goDigitPremium.option2 == null) {
        // this.modalService.show("thankYou"); 
        this.toasterService.showErrorToaster("Thank You, we will call you back in 24 hours.");
      } else {
        this.quotesDetailsTable = false;
        // if(insurer == "godigitInsurer1" || insurer == "godigitInsurer2" || insurer == "godigitInsurer3"){
        this.motorProposalPageGodigit = true;
        this.motorProposalPageHdfc = false;
        this.saveQuoteDetails("godigit", this.premiumOption);
        this.getAutopopulatedData();
        // }
      }
    }


  }

  getAutopopulatedData() {
    setTimeout(() => {
      this.f.firstName = localStorage.getItem("name").split(" ")[0];
      this.f.lastName = localStorage.getItem("name").split(" ")[1];
      console.log(this.f.lastName);
      this.f.mobile = localStorage.getItem("mobileNumber");
      this.f.email = localStorage.getItem("email")
    }, 500);
    this.currentDate = new Date();
    this.f.manufacturer = this.selectedManufaturerCode
    this.f.carModel = this.selectedModelOption
    this.policyStartDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    this.purchaseRegnDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    this.manufacturingYear = this.getDefaultManufacturingYear(this.purchaseRegnDate);
    this.prePolicyEndDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
  }

  changeSection() {
    this.quotesDetailsTable = true;
  }

  getCityStateList(pinCode) {
    this.f.pincode = pinCode;
    this.loading = true;
    this.data = {
      "pincode": JSON.stringify(this.f.pincode)
    }
    this.serviceURLService.getCityStateList(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.cityStateList = successData.data;
      this.cityList = successData.data.cityList;
      this.stateFirst = successData.data.state;
      console.log(this.stateFirst);
      this.loading = false;

      if (this.cityList.length == 0) {
        // var proceedButton = <HTMLInputElement>document.getElementById("proceedPayment");
        // proceedButton.disabled = true;
        this.invalidPincode = true;
      }
      else {
        this.invalidPincode = false;
      }
    }, errorData => {
      console.log("Oops..!! city/state list not found");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  // ................... To Calculate Premium (on click of Buy Now)........................
  calculatePremium(insurer) {
    this.loading = true;
    // var citySelected = (<HTMLInputElement>document.getElementById("city")).value;
    if (this.regDate) {
      var vehicleRegistrationDate = this.datepipe.transform(this.regDate, 'dd/MM/yyyy');
    } else {
      vehicleRegistrationDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    }
    let todaysDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');

    console.log("902" + this.premiumOption);
    // for motor Add On covers
    if (this.premiumOption == "0") {
      // this.electricalAcc = "1";
      // this.nonElectricalAcc = "1";
      // this.lpgCng = "1";
      this.zeroDepreciation = "true";   //Parts Depreciation Cover
      // this.isNcbProtection = "1";
      this.isEngineProtection = "true"; //Engine And Gear Box ProtectionCover
      this.isCostOfConsumable = "true"; //Consumable Cover
      this.roadSideAssistance = "true"; //Breakdown Assistance Cover
      this.isrtiCovered = "true";       //Return To Invoice Cover
      this.isRimDamageCover = "true";   //Rim Damage Cover
      this.isTyreCover = "true";        //Tyre Protect Cover
    } else if (this.premiumOption == "1") {
      this.zeroDepreciation = "true";   //Parts Depreciation Cover
      // this.isNcbProtection = "1";
      this.isEngineProtection = "true"; //Engine And Gear Box ProtectionCover
      this.isCostOfConsumable = "true"; //Consumable Cover
      this.roadSideAssistance = "true"; //Breakdown Assistance Cover
      this.isrtiCovered = "false";       //Return To Invoice Cover
      this.isRimDamageCover = "false";   //Rim Damage Cover
      this.isTyreCover = "false";        //Tyre Protect Cover
    } else if (this.premiumOption == "2") {
      this.zeroDepreciation = "false";   //Parts Depreciation Cover
      // this.isNcbProtection = "1";
      this.isEngineProtection = "false"; //Engine And Gear Box ProtectionCover
      this.isCostOfConsumable = "false"; //Consumable Cover
      this.roadSideAssistance = "false"; //Breakdown Assistance Cover
      this.isrtiCovered = "false";       //Return To Invoice Cover
      this.isRimDamageCover = "false";   //Rim Damage Cover
      this.isTyreCover = "false";        //Tyre Protect Cover
    }


    if (insurer == "hdfc") {
      this.data = {
        company: "",
        location: this.citySelected,
        mobile: localStorage.getItem("mobileNumber"),
        email: localStorage.getItem("email"),
        couponCode: "",
        businessType: this.typeOptions,
        manufacturerCode: this.selectedKeyValue,
        vehicleModel: this.selectedModelKeyValue,
        stateCode: this.selectedStateKey,
        purchaseCity: this.selectedCityKey,
        purchaseRegnDate: this.purchaseRegnDate,
        isPreviousClaim: this.claimOpt,
        isPreviousDiscount: this.isPreviousDiscount,
        policyStartDate: this.policyStartDate,
        prePolicyStartDate: this.prePolicyStartDate,
        prePolicyEndDate: this.prePolicyEndDate,
        manufacturingYear: JSON.stringify(this.manufacturingYear),
        policyEndDate: this.getModifiedDate(todaysDate, 1, -1, 0),
        age: "Up to 35",
        electricalAcc: "0",
        nonElectricalAcc: "0",
        lpgCng: "0",
        manufacturer: this.selectedManufaturerCode,
        vehicleModelName: this.selectedModelName,
        state: this.selectedStateValue,
        purchaseCityName: this.selectedCityValue,
        quoteId: this.motorQuoteId,
        prospectId: localStorage.getItem("prospectIdMotor"),
        // prospectId: "447697",
        goDigitVehicleModel: JSON.stringify(this.goDigitVehicleCode),
        vehicleRegnNo: this.vehicleRtoCode,
        sumInsured: this.idvRange.sumInsured,
        exshowRoomPrice: this.idvRange.exShowRoomPrice,
        totalIDV1: this.idvRange.minSumInsured,
        totalIDV2: this.idvRange.minSumInsured,
        totalIDV3: this.idvRange.minSumInsured,
        premium1: this.hdfcPremium.option0,
        premium2: this.hdfcPremium.option1,
        premium3: this.hdfcPremium.option2,
        electrical1: this.electricalHdfcBasic,
        electrical2: this.electricalHdfcEssential,
        electrical3: this.electricalHdfcComprehensive,
        nonElectrical1: this.nonElectricalHdfcBasic,
        nonElectrical2: this.nonElectricalHdfcEssential,
        nonElectrical3: this.nonElectricalHdfcComprehensive,
        cngLpg1: this.hdfcCngLpgBasic,
        cngLpg2: this.hdfcCngLpgEssential,
        cngLpg3: this.hdfcCngLpgComprehensive,
        zeroDepreciation1: "0",
        zeroDepreciation2: "1",
        zeroDepreciation3: "1",
        rti1: this.roi1,
        rti2: "0",
        rti3: "0",
        ncb1: this.ncb1,
        ncb2: "0",
        ncb3: "0",
        isConsumable1: this.consumable1,
        isConsumable2: "0",
        isConsumable3: "0",
        keyReplacement1: this.keyReplacement,
        keyReplacement2: "0",
        keyReplacement3: "0",
        roadSideAssistance1: this.roadSideAssistance1,
        roadSideAssistance2: "0",
        roadSideAssistance3: "0",
        engineProtection1: this.engine1,
        engineProtection2: "0",
        engineProtection3: "0",
        insurer1: "hdfc",
        insurer2: "hdfc",
        insurer3: "hdfc",
        isTyre1: this.tyreCover,
        isTyre2: "0",
        isTyre3: "0",
        isRimDamage1: this.rimDamage,
        isRimDamage2: "0",
        isRimDamage3: "0",
        isPaUnnamedPassenger1: "1",
        isPaUnnamedPassenger2: "1",
        isPaUnnamedPassenger3: "1",
        isrtiCovered: "0",
        roadSideAssistance: "1",
        zeroDepreciation: "1",
        isAsstWiderCover: "1",
        isEngineProtection: "1",
        isCostOfConsumable: "1",
        isNcbProtection: "1",
        isTyreCover: "0",
        isRimDamageCover: "0",
        // insurer0: "hdfc",
        option: "0",
        gender: this.f.title,
        firstName: this.f.firstName,
        lastName: this.f.lastName,
        dob: this.f.dob,
        emailId: this.f.email,
        occupationType: this.f.occupation,
        designation: this.f.designation,
        annualIncome: this.f.annualIncome,
        panNumber: this.f.pan,
        aadhar: this.f.adhaar,
        carAddress: this.f.address1,
        carPin: this.f.pincode,
        districtName: this.f.state,
        engineNo: this.engineNumberLead,
        chassisNo: this.chasisNumberLead,
        manufacturingDate: this.manufaturingDate,
        manufacturerName: this.selectedManufaturerCode,
        fuelType: this.fuel,
        paymentMode: "",
        recieveSMS: "0",
        termCheck: "0",
        renewalPremiums: "0",
        otp: this.hdfcOtp,
        prePolicyNumber: "0",
        cityCode: this.selectedCityKey,
        district: this.area,
        zeroDeptRollover: 0,
        occupation: this.f.occupation,
      }

      this.serviceURLService.motorCalculatePremiumHdfc(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        // console.log("successData Save details ",successData);
        this.totalPremiumForHdfc = successData.data.totalPremium;

        // this.toasterService.showErrorToaster(successData.message);
      }, errorData => {
        console.log("Oops..!! there is some error in Save Motor Proposal");
        this.error = errorData.error.message;
        // this.toasterService.showErrorToaster(this.error);
        if (errorData.error.status === 403) {
          this.error = errorData.error.message;
        }
      })
    } else {
      this.data = {
        businessType: this.typeOptions,
        manufacturerCode: this.selectedKeyValue,
        vehicleModel: this.selectedModelKeyValue,
        stateCode: this.selectedStateKey,
        purchaseCity: this.selectedCityKey,
        purchaseRegnDate: this.purchaseRegnDate,
        isPreviousClaim: this.claimOpt,
        isPreviousDiscount: this.isPreviousDiscount,
        policyStartDate: this.policyStartDate,
        prePolicyStartDate: this.prePolicyStartDate,
        prePolicyEndDate: this.prePolicyEndDate,
        manufacturingYear: JSON.stringify(this.manufacturingYear),
        manufacturingDate: this.manufaturingDateLead,
        policyEndDate: this.getModifiedDate(todaysDate, 1, -1, 0),
        age: "Up to 35",
        electricalAcc: false,
        nonElectricalAcc: false,
        lpgCng: false,
        manufacturer: this.selectedManufaturerCode,
        vehicleModelName: this.selectedModelName,
        state: this.selectedStateValue,
        purchaseCityName: this.selectedCityValue,
        quoteId: JSON.stringify(this.motorQuoteId),
        prospectId: localStorage.getItem("prospectIdMotor"),
        goDigitVehicleModel: JSON.stringify(this.goDigitVehicleCode),
        // vehicleRegnNo: this.vehicleRtoCode,
        vehicleRegnNo: this.vehicleRegNumLead,
        // engineNo: this.f.engineNumber,
        // chassisNo: this.f.chasisNumber,
        engineNo: this.engineNumberLead,
        chassisNo: this.chasisNumberLead,
        sumInsured: JSON.stringify(this.goDigitIdvRange.sumInsured),
        zeroDepreciation: this.zeroDepreciation,
        isrtiCovered: this.isrtiCovered,
        isNcbProtection: this.isNcbProtection,
        isEngineProtection: this.isEngineProtection,
        roadSideAssistance: this.roadSideAssistance,
        isCostOfConsumable: this.isCostOfConsumable,
        isRimDamageCover: this.isRimDamageCover,
        isTyreCover: this.isTyreCover,

        subInsuranceProductCode: this.subInsuranceOnLead,
        pincode: this.f.pincode,
        partsDepreciation: this.zeroDepreciation,
        returnToInvoice: this.isrtiCovered,
      }

      this.serviceURLService.motorCalculatePremiumGoDigit(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        this.loading = false;
        // console.log("successData Save details ",successData);

        // this.totalPremiumForGoDigit = successData.data.basePremium;
        // this.goDigitServiceTax = successData.data.totalTaxAmount;
        // this.totalPremiumIncludedTaxGoDigit = JSON.parse(this.totalPremiumForGoDigit) + JSON.parse(this.goDigitServiceTax);
        // console.log(this.totalPremiumIncludedTaxGoDigit);

        // this.totalPremiumIncludedTaxGoDigit = successData.data.PremiumIncludesTax;
        // this.goDigitServiceTax = JSON.parse(this.totalPremiumIncludedTaxGoDigit) - JSON.parse(this.totalPremiumForGoDigit)
        // this.toasterService.showErrorToaster(successData.message);
        this.saveProposalGodigit();
      }, errorData => {
        console.log("Oops..!! there is some error in Save Motor Proposal");
        this.error = errorData.error.message;
        // this.toasterService.showErrorToaster(this.error);
        if (errorData.error.status === 403) {
          this.error = errorData.error.message;
        }
      })
    }
  }


  // ....................... To Save HDFC Proposal Page Details ......................
  saveProposalHdfc() {
    // this.loading = true;
    // var citySelected = (<HTMLInputElement>document.getElementById("city")).value;
    if (this.regDate) {
      var vehicleRegistrationDate = this.datepipe.transform(this.regDate, 'dd/MM/yyyy');
    } else {
      vehicleRegistrationDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    }
    let todaysDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');

    this.data = {
      company: "",
      location: this.citySelected,
      mobile: localStorage.getItem("mobileNumber"),
      email: localStorage.getItem("email"),
      couponCode: "",
      businessType: this.typeOptions,
      manufacturerCode: this.selectedKeyValue,
      vehicleModel: this.selectedModelKeyValue,
      stateCode: this.selectedStateKey,
      purchaseCity: this.selectedCityKey,
      purchaseRegnDate: this.purchaseRegnDate,
      isPreviousClaim: this.claimOpt,
      isPreviousDiscount: this.isPreviousDiscount,
      policyStartDate: this.policyStartDate,
      prePolicyStartDate: this.prePolicyStartDate,
      prePolicyEndDate: this.prePolicyEndDate,
      manufacturingYear: JSON.stringify(this.manufacturingYear),
      policyEndDate: this.getModifiedDate(todaysDate, 1, -1, 0),
      age: "Up to 35",
      electricalAcc: "0",
      nonElectricalAcc: "0",
      lpgCng: "0",
      manufacturer: this.selectedManufaturerCode,
      vehicleModelName: this.selectedModelName,
      state: this.selectedStateValue,
      purchaseCityName: this.selectedCityValue,
      quoteId: this.motorQuoteId,
      prospectId: localStorage.getItem("prospectIdMotor"),
      // prospectId: "447697",
      goDigitVehicleModel: JSON.stringify(this.goDigitVehicleCode),
      vehicleRegnNo: this.vehicleRtoCode + "AB1234",
      sumInsured: this.idvRange.sumInsured,
      exshowRoomPrice: this.idvRange.exShowRoomPrice,
      totalIDV1: this.idvRange.minSumInsured,
      totalIDV2: this.idvRange.minSumInsured,
      totalIDV3: this.idvRange.minSumInsured,
      premium1: this.hdfcPremium.option0,
      premium2: this.hdfcPremium.option1,
      premium3: this.hdfcPremium.option2,
      electrical1: this.electricalHdfcBasic,
      electrical2: this.electricalHdfcEssential,
      electrical3: this.electricalHdfcComprehensive,
      nonElectrical1: this.nonElectricalHdfcBasic,
      nonElectrical2: this.nonElectricalHdfcEssential,
      nonElectrical3: this.nonElectricalHdfcComprehensive,
      cngLpg1: this.hdfcCngLpgBasic,
      cngLpg2: this.hdfcCngLpgEssential,
      cngLpg3: this.hdfcCngLpgComprehensive,
      zeroDepreciation1: "0",
      zeroDepreciation2: "1",
      zeroDepreciation3: "1",
      rti1: this.roi1,
      rti2: "0",
      rti3: "0",
      ncb1: this.ncb1,
      ncb2: "0",
      ncb3: "0",
      isConsumable1: this.consumable1,
      isConsumable2: "0",
      isConsumable3: "0",
      keyReplacement1: this.keyReplacement,
      keyReplacement2: "0",
      keyReplacement3: "0",
      roadSideAssistance1: this.roadSideAssistance1,
      roadSideAssistance2: "0",
      roadSideAssistance3: "0",
      engineProtection1: this.engine1,
      engineProtection2: "0",
      engineProtection3: "0",
      insurer1: "hdfc",
      insurer2: "hdfc",
      insurer3: "hdfc",
      isTyre1: this.tyreCover,
      isTyre2: "0",
      isTyre3: "0",
      isRimDamage1: this.rimDamage,
      isRimDamage2: "0",
      isRimDamage3: "0",
      isPaUnnamedPassenger1: "1",
      isPaUnnamedPassenger2: "1",
      isPaUnnamedPassenger3: "1",


      isrtiCovered: "0",
      roadSideAssistance: "1",
      zeroDepreciation: "1",
      isAsstWiderCover: "1",
      isEngineProtection: "1",
      isCostOfConsumable: "1",
      isNcbProtection: "1",
      isTyreCover: "0",
      isRimDamageCover: "0",
      insurer0: "hdfc",
      option: "0",
      gender: this.f.title,
      firstName: this.f.firstName,
      lastName: this.f.lastName,
      dob: this.f.dob,
      emailId: this.f.email,
      occupationType: this.f.occupation,
      designation: this.f.designation,
      annualIncome: this.f.annualIncome,
      panNumber: this.f.pan,
      aadhar: this.f.adhaar,
      carAddress: this.f.address1,
      carPin: this.f.pincode,
      districtName: this.f.state,
      engineNo: this.f.engineNumber,
      chassisNo: this.f.chasisNumber,
      manufacturingDate: this.manufaturingDate,
      manufacturerName: this.selectedManufaturerCode,
      fuelType: this.fuel,
      paymentMode: "",
      recieveSMS: "0",
      termCheck: "0",
      renewalPremiums: "0",
      otp: this.hdfcOtp,
      prePolicyNumber: "0",
      cityCode: this.selectedCityKey,
      district: this.area,
      occupation: this.f.occupation,
    }

    this.serviceURLService.saveMotorProposalHdfc(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // console.log("successData Save details ",successData);
      this.toasterService.showErrorToaster(successData.message);
      this.loading = false;
    }, errorData => {
      this.loading = false;
      console.log("Oops..!! there is some error in Save Motor Proposal");
      this.error = errorData.error.message;
      this.toasterService.showErrorToaster(this.error);
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })

  }

  // .............. To save GoDigit Proposal Page ....................
  saveProposalGodigit() {
    // this.loading = true;
    // var citySelected = (<HTMLInputElement>document.getElementById("city")).value;
    if (this.regDate) {
      var vehicleRegistrationDate = this.datepipe.transform(this.regDate, 'dd/MM/yyyy');
    } else {
      vehicleRegistrationDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    }
    let todaysDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');

    console.log("1471" + this.premiumOption);
    // for motor Add On covers
    if (this.premiumOption == "0") {
      // this.electricalAcc = "1";
      // this.nonElectricalAcc = "1";
      // this.lpgCng = "1";
      this.zeroDepreciation = "1";   //Parts Depreciation Cover
      // this.isNcbProtection = "1";
      this.isEngineProtection = "1"; //Engine And Gear Box ProtectionCover
      this.isCostOfConsumable = "1"; //Consumable Cover
      this.roadSideAssistance = "1"; //Breakdown Assistance Cover
      this.isrtiCovered = "1";       //Return To Invoice Cover
      this.isRimDamageCover = "1";   //Rim Damage Cover
      this.isTyreCover = "1";        //Tyre Protect Cover
    } else if (this.premiumOption == "1") {
      this.zeroDepreciation = "1";   //Parts Depreciation Cover
      // this.isNcbProtection = "1";
      this.isEngineProtection = "1"; //Engine And Gear Box ProtectionCover
      this.isCostOfConsumable = "1"; //Consumable Cover
      this.roadSideAssistance = "1"; //Breakdown Assistance Cover
      this.isrtiCovered = "0";       //Return To Invoice Cover
      this.isRimDamageCover = "0";   //Rim Damage Cover
      this.isTyreCover = "0";        //Tyre Protect Cover
    } else if (this.premiumOption == "2") {
      this.zeroDepreciation = "0";   //Parts Depreciation Cover
      // this.isNcbProtection = "1";
      this.isEngineProtection = "0"; //Engine And Gear Box ProtectionCover
      this.isCostOfConsumable = "0"; //Consumable Cover
      this.roadSideAssistance = "0"; //Breakdown Assistance Cover
      this.isrtiCovered = "0";       //Return To Invoice Cover
      this.isRimDamageCover = "0";   //Rim Damage Cover
      this.isTyreCover = "0";        //Tyre Protect Cover
    }

    this.data = {
      company: "",
      location: this.citySelected,
      mobile: localStorage.getItem("mobileNumber"),
      email: localStorage.getItem("email"),
      couponCode: "",
      businessType: this.typeOptions,
      manufacturerCode: this.selectedKeyValue,
      vehicleModel: this.selectedModelKeyValue,
      stateCode: this.selectedStateKey,
      purchaseCity: this.selectedCityKey,
      purchaseRegnDate: this.purchaseRegnDate,
      isPreviousClaim: this.claimOpt,
      isPreviousDiscount: this.isPreviousDiscount,
      policyStartDate: this.policyStartDate,
      prePolicyStartDate: this.prePolicyStartDate,
      prePolicyEndDate: this.prePolicyEndDate,
      manufacturingYear: JSON.stringify(this.manufacturingYear),
      policyEndDate: this.getModifiedDate(todaysDate, 1, -1, 0),
      age: "Up to 35",
      electricalAcc: "0",
      nonElectricalAcc: "0",
      lpgCng: "0",
      manufacturer: this.selectedManufaturerCode,
      vehicleModelName: this.selectedModelName,
      state: this.selectedStateValue,
      purchaseCityName: this.selectedCityValue,
      quoteId: this.motorQuoteId,
      prospectId: localStorage.getItem("prospectIdMotor"),
      // prospectId: "447697",
      goDigitVehicleModel: JSON.stringify(this.goDigitVehicleCode),
      vehicleRegnNo: this.vehicleRegNumLead,
      sumInsured: this.goDigitIdvRange.sumInsured,
      exshowRoomPrice: this.goDigitIdvRange.exShowRoomPrice,
      insurer0: "goDigit",
      option: this.premiumOption,
      gender: this.f.title,
      firstName: this.f.firstName,
      lastName: this.f.lastName,
      dob: this.f.dob,
      emailId: this.f.email,
      occupationType: this.f.occupation,
      designation: this.f.designation,
      annualIncome: this.f.annualIncome,
      panNumber: this.f.pan,
      aadhar: this.f.adhaar,
      flatNumber: this.f.address1,
      street: this.f.address2,
      pincode: this.f.pincode,
      districtName: this.f.state,
      engineNo: this.f.engineNumber,
      chassisNo: this.f.chasisNumber,
      manufacturingDate: this.manufaturingDate,
      manufacturerName: this.selectedManufaturerCode,
      fuelType: this.fuel,
      paymentMode: "",
      recieveSMS: "0",
      termCheck: "0",
      renewalPremiums: "0",
      otp: this.hdfcOtp,
      prePolicyNumber: "0",
      cityCode: this.selectedCityKey,
      district: this.area,
      occupation: this.f.occupation,

      // electricalAcc: this.electricalAcc,
      // nonElectricalAcc: this.nonElectricalAcc,
      // lpgCng: this.lpgCng,
      zeroDepreciation: this.zeroDepreciation,
      isrtiCovered: this.isrtiCovered,
      isNcbProtection: this.isNcbProtection,
      isEngineProtection: this.isEngineProtection,
      roadSideAssistance: this.roadSideAssistance,
      isCostOfConsumable: this.isCostOfConsumable,
      isRimDamageCover: this.isRimDamageCover,
      isTyreCover: this.isTyreCover
    }

    this.serviceURLService.saveMotorProposalGodigit(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // console.log("successData Save details go Digit ",successData);
      this.toasterService.showErrorToaster(successData.message);
      this.loading = false;
    }, errorData => {
      console.log("Oops..!! there is some error in Save Motor Proposal GoDigit");
      this.error = errorData.error.message;
      this.toasterService.showErrorToaster(this.error);
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })

  }

  sendOtpFunc() {
    var proposersMobile = this.f.mobile

    this.serviceURLService.getMotorHdfcOtp(proposersMobile).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.verifyOtpBtn = true;
      // console.log("successData Save details ",successData);
      this.hdfcOtp = successData.data;
      this.toasterService.showErrorToaster(successData.message);
    }, errorData => {
      console.log("Oops..!! there is some error in Save Motor Proposal");
      this.error = errorData.error.message;
      this.toasterService.showErrorToaster(this.error);
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  verifyOtpFunc(enteredOtp) {
    if (enteredOtp == this.hdfcOtp) {
      this.toasterService.showErrorToaster("OTP verified successfully");
      this.otpVerified = true;
      this.calculatePremium("hdfc");
      this.saveProposalHdfc();
    } else {
      this.toasterService.showErrorToaster("Please enter correct OTP");
      this.otpVerified = false;
    }
  }

  // for tab change functionality
  details(activeTab) {
    this.activeTab = activeTab;
  }

  vehicle(activeTab) {
    this.activeTab = activeTab;
  }



  getSelectedOccupation(event) {
    this.selectedOccupation = event.target.options[event.target.options.selectedIndex].text;
  }


  // ........... To submit HDFC proposal ............
  getHdfcProposal() {
    // var citySelected = (<HTMLInputElement>document.getElementById("city")).value;
    if (this.regDate) {
      var vehicleRegistrationDate = this.datepipe.transform(this.regDate, 'dd/MM/yyyy');
    } else {
      vehicleRegistrationDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    }
    let todaysDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    let proposalDob = this.datepipe.transform(this.proposalDob, 'dd/MM/yyyy');
    this.data = {
      company: "",
      location: this.citySelected,
      mobile: localStorage.getItem("mobileNumber"),
      email: localStorage.getItem("email"),
      couponCode: "",
      businessType: this.typeOptions,
      manufacturerCode: this.selectedKeyValue,
      vehicleModel: this.selectedModelKeyValue,
      stateCode: this.selectedStateKey,
      purchaseCity: this.selectedCityKey,
      purchaseRegnDate: this.purchaseRegnDate,
      isPreviousClaim: this.claimOpt,
      isPreviousDiscount: this.isPreviousDiscount,
      policyStartDate: this.policyStartDate,
      prePolicyStartDate: this.prePolicyStartDate,
      prePolicyEndDate: this.prePolicyEndDate,
      manufacturingYear: JSON.stringify(this.manufacturingYear),
      policyEndDate: this.getModifiedDate(todaysDate, 1, -1, 0),
      age: "Up to 35",
      electricalAcc: "0",
      nonElectricalAcc: "0",
      lpgCng: "0",
      manufacturer: this.selectedManufaturerCode,
      vehicleModelName: this.selectedModelName,
      state: this.selectedStateValue,
      purchaseCityName: this.selectedCityValue,
      quoteId: this.motorQuoteId,
      prospectId: localStorage.getItem("prospectIdMotor"),
      // prospectId: "447697",
      goDigitVehicleModel: JSON.stringify(this.goDigitVehicleCode),
      vehicleRegnNo: this.vehicleRtoCode + "AB1234",
      sumInsured: this.idvRange.sumInsured,
      exshowRoomPrice: this.idvRange.exShowRoomPrice,
      totalIDV1: this.idvRange.minSumInsured,
      totalIDV2: this.idvRange.minSumInsured,
      totalIDV3: this.idvRange.minSumInsured,
      premium1: this.hdfcPremium.option0,
      premium2: this.hdfcPremium.option1,
      premium3: this.hdfcPremium.option2,
      electrical1: this.electricalHdfcBasic,
      electrical2: this.electricalHdfcEssential,
      electrical3: this.electricalHdfcComprehensive,
      nonElectrical1: this.nonElectricalHdfcBasic,
      nonElectrical2: this.nonElectricalHdfcEssential,
      nonElectrical3: this.nonElectricalHdfcComprehensive,
      cngLpg1: this.hdfcCngLpgBasic,
      cngLpg2: this.hdfcCngLpgEssential,
      cngLpg3: this.hdfcCngLpgComprehensive,
      zeroDepreciation1: "0",
      zeroDepreciation2: "1",
      zeroDepreciation3: "1",
      rti1: this.roi1,
      rti2: "0",
      rti3: "0",
      ncb1: this.ncb1,
      ncb2: "0",
      ncb3: "0",
      isConsumable1: this.consumable1,
      isConsumable2: "0",
      isConsumable3: "0",
      keyReplacement1: this.keyReplacement,
      keyReplacement2: "0",
      keyReplacement3: "0",
      roadSideAssistance1: this.roadSideAssistance1,
      roadSideAssistance2: "0",
      roadSideAssistance3: "0",
      engineProtection1: this.engine1,
      engineProtection2: "0",
      engineProtection3: "0",
      insurer1: "hdfc",
      insurer2: "hdfc",
      insurer3: "hdfc",
      isTyre1: this.tyreCover,
      isTyre2: "0",
      isTyre3: "0",
      isRimDamage1: this.rimDamage,
      isRimDamage2: "0",
      isRimDamage3: "0",
      isPaUnnamedPassenger1: "1",
      isPaUnnamedPassenger2: "1",
      isPaUnnamedPassenger3: "1",
      isrtiCovered: "0",
      roadSideAssistance: "1",
      zeroDepreciation: "1",
      isAsstWiderCover: "1",
      isEngineProtection: "1",
      isCostOfConsumable: "1",
      isNcbProtection: "1",
      isTyreCover: "0",
      isRimDamageCover: "0",
      // insurer0: "hdfc",
      option: "0",
      gender: this.f.title,
      firstName: this.f.firstName,
      lastName: this.f.lastName,
      dob: proposalDob,
      emailId: this.f.email,
      occupationType: this.f.occupation,
      designation: this.f.designation,
      annualIncome: this.f.annualIncome,
      panNumber: this.f.pan,
      aadhar: this.f.adhaar,
      carAddress: this.f.address1,
      carPin: "",
      districtName: this.f.state,
      engineNo: this.f.engineNumber,
      chassisNo: this.f.chasisNumber,
      manufacturingDate: this.manufaturingDate,
      manufacturerName: this.selectedManufaturerCode,
      fuelType: this.fuel,
      paymentMode: "",
      recieveSMS: "0",
      termCheck: "0",
      renewalPremiums: "0",
      otp: this.hdfcOtp,
      prePolicyNumber: "0",
      cityCode: this.selectedCityKey,
      district: this.area,
      occupation: this.selectedOccupation,
      prePolicyInsurer: "",
    }

    this.serviceURLService.getHdfcProposal(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // console.log("successData Save details ",successData);
      this.toasterService.showErrorToaster(successData.message);
    }, errorData => {
      console.log("Oops..!! there is some error in Save Motor Proposal");
      this.error = errorData.error.message;
      this.toasterService.showErrorToaster(this.error);
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }


  // .............. To submit GoDigit proposal .............
  motorGoDigitGeneratePolicy() {
    this.loading = true;
    if (this.regDate) {
      var vehicleRegistrationDate = this.datepipe.transform(this.regDate, 'dd/MM/yyyy');
    } else {
      vehicleRegistrationDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    }
    let todaysDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    let proposalDob = this.datepipe.transform(this.proposalDob, 'dd/MM/yyyy');
    // let manufaturingDate = this.datepipe.transform(this.manufaturingDateLead, 'dd/MM/yyyy')

    console.log("1863 " + this.premiumOption);
    // for motor Add On covers
    if (this.premiumOption == "0") {
      // this.electricalAcc = "1";
      // this.nonElectricalAcc = "1";
      // this.lpgCng = "1";
      this.zeroDepreciation = "true";   //Parts Depreciation Cover
      // this.isNcbProtection = "1";
      this.isEngineProtection = "true"; //Engine And Gear Box ProtectionCover
      this.isCostOfConsumable = "true"; //Consumable Cover
      this.roadSideAssistance = "true"; //Breakdown Assistance Cover
      this.isrtiCovered = "true";       //Return To Invoice Cover
      this.isRimDamageCover = "true";   //Rim Damage Cover
      this.isTyreCover = "true";        //Tyre Protect Cover
    } else if (this.premiumOption == "1") {
      this.zeroDepreciation = "true";   //Parts Depreciation Cover
      // this.isNcbProtection = "1";
      this.isEngineProtection = "true"; //Engine And Gear Box ProtectionCover
      this.isCostOfConsumable = "true"; //Consumable Cover
      this.roadSideAssistance = "true"; //Breakdown Assistance Cover
      this.isrtiCovered = "false";       //Return To Invoice Cover
      this.isRimDamageCover = "false";   //Rim Damage Cover
      this.isTyreCover = "false";        //Tyre Protect Cover
    } else if (this.premiumOption == "2") {
      this.zeroDepreciation = "false";   //Parts Depreciation Cover
      // this.isNcbProtection = "1";
      this.isEngineProtection = "false"; //Engine And Gear Box ProtectionCover
      this.isCostOfConsumable = "false"; //Consumable Cover
      this.roadSideAssistance = "false"; //Breakdown Assistance Cover
      this.isrtiCovered = "false";       //Return To Invoice Cover
      this.isRimDamageCover = "false";   //Rim Damage Cover
      this.isTyreCover = "false";        //Tyre Protect Cover
    }


    this.data = {
      zeroDepreciation: this.zeroDepreciation,
      isrtiCovered: this.isrtiCovered,
      isNcbProtection: this.isNcbProtection,
      isEngineProtection: this.isEngineProtection,
      roadSideAssistance: this.roadSideAssistance,
      isCostOfConsumable: this.isCostOfConsumable,
      isRimDamageCover: this.isRimDamageCover,
      isTyreCover: this.isTyreCover,
      "pincode": this.f.pincode,
      flatNumber: this.f.address1,
      street: this.f.address2,
      "age": "Up to 35",
      "annualIncome": this.f.annualIncome,
      "businessType": this.typeOptions,
      "carPin": "",
      "cityCode": this.selectedCityKey,
      "company": "",
      "couponCode": "",
      "designation": this.f.designation,
      "email": localStorage.getItem("email"),
      "gender": this.f.title,
      "firstName": this.f.firstName,
      "lastName": this.f.lastName,
      "dob": proposalDob,
      "goDigitVehicleModel": JSON.stringify(this.goDigitVehicleCode),
      "isAsstWiderCover": "1",
      "isPreviousClaim": this.claimOpt,
      "isPreviousDiscount": this.isPreviousDiscount,
      "location": this.citySelected,
      "lpgCng": false,
      "electricalAcc": false,
      "nonElectricalAcc": false,
      "manufacturer": this.selectedManufaturerCode,
      "manufacturerCode": this.selectedKeyValue,
      "manufacturingDate": this.manufaturingDateLead,
      "manufacturerName": this.selectedManufaturerCode,
      "manufacturingYear": JSON.stringify(this.manufacturingYear),
      "mobile": localStorage.getItem("mobileNumber"),
      "option": this.premiumOption,
      "panNumber": this.f.pan,
      "policyEndDate": this.getModifiedDate(todaysDate, 1, -1, 0),
      "policyStartDate": this.policyStartDate,
      "prePolicyStartDate": this.prePolicyStartDate,
      "prePolicyEndDate": this.prePolicyEndDate,
      "prePolicyInsurer": "",
      "prePolicyNumber": "0",
      "quoteId": this.motorQuoteId,
      "prospectId": localStorage.getItem("prospectIdMotor"),
      "purchaseCity": this.selectedCityKey,
      "purchaseCityName": this.selectedCityValue,
      "purchaseRegnDate": this.purchaseRegnDate,
      "recieveSMS": "0",
      "renewalPremiums": "0",
      "state": this.selectedStateValue,
      "stateCode": this.selectedStateKey,
      "sumInsured": JSON.stringify(this.goDigitIdvRange.sumInsured),
      "termCheck": "0",
      "vehicleModel": this.selectedModelKeyValue,
      "vehicleModelName": this.selectedModelName,
      "vehicleRegnNo": this.vehicleRegNumLead,
      "engineNo": this.engineNumberLead,
      "chassisNo": this.chasisNumberLead,
      // "zeroDepreciation": true,
      // "isRimDamageCover": true,
      // "isTyreCover": true,
      // "isrtiCovered": true,
      // "isCostOfConsumable": true,
      // "isEngineProtection": true,
      // "isNcbProtection": "1",
      // "roadSideAssistance": true,
      "subInsuranceProductCode": this.subInsuranceOnLead ? this.subInsuranceOnLead : "",
      "prePolicyInsurerCode": this.f.previousInsurer ? this.f.previousInsurer : "",
      "city": this.citySelected
    }

    this.serviceURLService.motorGoDigitGeneratePolicy(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      console.log("successData Save details ", successData);
      // this.toasterService.showErrorToaster(successData.message);
      // this.getGodigitPaymentAck();
      // var paymentRepaymentRedirectionUrl = successData.data.paymentUrl;
      // window.location.href = paymentRedirectionUrl;
      this.totalPremiumForGoDigit = successData.data.netPremium;
      this.goDigitServiceTax = successData.data.serviceTax;
      this.totalPremiumIncludedTaxGoDigit = successData.data.totalGrossPremium;
      console.log(this.totalPremiumIncludedTaxGoDigit);

      // this.motorInitiateToPaymentGoDigit(applicationId, secureNowTxnRefNo);
      localStorage.setItem("applicationId", successData.data.applicationId);
      localStorage.setItem("secureNowTxnRefNo", successData.data.secureNowTxnRefNo);

      this.loading = false;
    }, errorData => {
      this.modalRef.hide();
      console.log("Oops..!! there is some error in Save Motor Proposal");
      this.loading = false;
      this.error = errorData.error.message;
      this.toasterService.showErrorToaster(this.error);
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  //initiate payment gateway
  motorInitiateToPaymentGoDigit() {
    this.loading = true;
    var applicationId = localStorage.getItem("applicationId")
    var secureNowTxnRefNo = localStorage.getItem("secureNowTxnRefNo");
    this.data = {
      applicationId: applicationId,
      secureNowTxnRefNo: secureNowTxnRefNo
    }
    this.serviceURLService.motorInitiatePayment(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      var paymentRedirectionUrl = successData.data;
      window.location.href = paymentRedirectionUrl;
      console.log(paymentRedirectionUrl);

    }, errorData => {
      console.log("Oops..!! Error");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  // Get Go-Digit Payment Acknowledgment 
  getGodigitPaymentAck() {
    this.loading = true;
    this.data = {

    }

    this.serviceURLService.getGodigitPaymentAck(this.data, this.txnId, this.transactionNo).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // console.log("successData Save details ",successData);
      this.toasterService.showErrorToaster(successData.message);
      this.hdfcThankyouSection = true;
    }, errorData => {
      console.log("Oops..!! there is some error in Save Motor Proposal");
      this.error = errorData.error.message;
      this.toasterService.showErrorToaster(this.error);
      this.hdfcTransactionFailureSection = true;
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }


  onTypeChange(event) {
    // console.log("typeOptionValue ",event)
    let todaysDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    if (this.regDate) {
      var vehicleRegistrationDate = this.datepipe.transform(this.regDate, 'dd/MM/yyyy');
    } else {
      vehicleRegistrationDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    }
    if (event == "Rollover") {
      this.getGodigitPreviousInsurer();
      this.typeOptionsSection = true;
      this.prePolicyEndDate = this.getModifiedDate(this.currentDate, 0, 1, 0);
      this.prePolicyStartDate = this.getModifiedDate(this.prePolicyEndDate, -1, 1, 0);
      this.policyStartDate = this.getModifiedDate(this.prePolicyEndDate, 0, 1, 0);
      this.purchaseRegnDate = vehicleRegistrationDate;
      this.manufacturingYear = this.getDefaultManufacturingYear(this.purchaseRegnDate);
      this.isPreviousClaim = this.claimOpt;
      this.isPreviousDiscount = this.previousDiscount;
      this.f.subInsurance = "PB";
      this.newBusinessType = false;
    } else {
      this.typeOptionsSection = false;
      this.policyStartDate = this.currentDate;
      this.purchaseRegnDate = todaysDate;
      this.prePolicyStartDate = "01/01/1990";
      this.prePolicyEndDate = todaysDate;
      this.manufacturingYear = this.getDefaultManufacturingYear(this.purchaseRegnDate);
      this.isPreviousClaim = "0";
      this.isPreviousDiscount = "0";
      // this.previousInsurerCode = "";
    }
  }

  onInsurerSelect(event) {
    // console.log("insurerSelected ",event)
    this.insurerValue = event;
    this.saveQuoteDetails(this.insurerValue, this.premiumOption);
    if (this.insurerValue == "goDigit") {
      if (this.goDigitData != null) {
        this.hdfcData = this.goDigitData;
        this.idvRange = this.goDigitIdvRange;
        this.idvRange.minSumInsured = this.goDigitIdvRange.minSumInsured;
        this.idvRange.maxSumInsured = this.goDigitIdvRange.maxSumInsured;
      } else {
        this.hdfcData = null;
      }

    } else {
      // console.log("m in else ",this.insurerValue)
      // this.hdfcData = null;
      // this.submitDetails();
      this.hdfcData = this.hdfcFirstData;
      this.idvRange = this.idvRange;
      this.idvRange.minSumInsured = this.idvRange.minSumInsured;
      this.idvRange.maxSumInsured = this.idvRange.maxSumInsured;
    }
  }

  getPreviousClaim(event) {
    if (event == "0") {
      this.claimOpt = "0"
    } else {
      this.claimOpt = "1"
    }

  }

  getPreviousNcb(event) {
    this.previousDiscount = event;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false });
  }

  getAddOnCovers(addOnInsurer) {
    this.saveQuoteDetails(addOnInsurer, this.premiumOption);
    console.log("addOnInsurer ", addOnInsurer);

    // this.calculatePremium(addOnInsurer);
  }

  getDefaultManufacturingYear(selectedDate) {
    var from = selectedDate.split("/");
    var mydate = new Date(from[2], from[1] - 1, from[0]);
    var year = mydate.getFullYear();
    return year;
  }

  getModifiedDate(referenceDate, year, date, month) {
    referenceDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy');
    var from = referenceDate.split("/");
    this.month1 = parseInt(from[1]) - 1;
    var mydate = new Date(from[2], this.month1.toString(), from[0]);
    mydate.setDate(mydate.getDate() + date);
    mydate.setMonth(mydate.getMonth() + month);
    mydate.setFullYear(mydate.getFullYear() + year);
    return ("0" + mydate.getDate()).slice(-2) + '/' + ("0" + (mydate.getMonth() + 1)).slice(-2) + '/' + mydate.getFullYear();
  }

  hdfcPincodeValidate(pincodeVal) {
    this.loading = true;
    if (JSON.stringify(pincodeVal).length == 6) {
      this.serviceURLService.getHdfcPincodeSorted().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        // console.log("successData Save details ",successData);
        this.loading = false;
        var pincodeList = successData
        var newAreaListA = [];
        for (let i = 1; i <= pincodeList.length; i++) {
          if (pincodeList[i].D == pincodeVal) {
            this.f.city = pincodeList[i].B;
            this.f.state = pincodeList[i].F;
            newAreaListA.push(pincodeList[i].C);
            this.areaList = newAreaListA;
          }
        }
      }, errorData => {
        console.log("Oops..!! there is some error in Entered Poincode");
        this.loading = false;
        this.error = errorData.error.message;
        this.toasterService.showErrorToaster(this.error);
        if (errorData.error.status === 403) {
          this.error = errorData.error.message;
        }
      })
    } else {
      this.loading = false;
      this.toasterService.showErrorToaster("Invalid Pincode");
      return;
    }
  }



  goDigitPincodeValidate(pincodeVal) {
    this.loading = true;
    // var cityValue = (<HTMLInputElement>document.getElementById("city")).value;
    if (JSON.stringify(pincodeVal).length == 6) {
      if (pincodeVal >= 110001 && pincodeVal <= 445402) {
        this.serviceURLService.getGodigitPincodeSortedA().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
          // console.log("successData Save details ",successData);
        
          this.loading = false;
          var pincodeList = successData.data;
          var newAreaListA = [];
          // if (cityValue) {
          //   console.log(cityValue);
          //   for (let i = 1; i <= pincodeList.length; i++) {
          //     if (pincodeList[i].B == cityValue) {
          //       console.log(cityValue);
          //     }
          //   }
          // }
          for (let i = 1; i <= pincodeList.length; i++) {
            if (pincodeList[i].D == pincodeVal) {
              this.f.city = pincodeList[i].B;
              this.f.state = pincodeList[i].F;
              newAreaListA.push(pincodeList[i].C);
              this.areaList = newAreaListA;
            }
          }
        }, errorData => {
          console.log("Oops..!! there is some error in Entered Poincode");
          this.loading = false;
          this.error = errorData.error.message;
          this.toasterService.showErrorToaster(this.error);
          if (errorData.error.status === 403) {
            this.error = errorData.error.message;
          }
        })
      } else if (pincodeVal >= 450001 && pincodeVal <= 855117) {
        this.serviceURLService.getGodigitPincodeSortedB().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
          this.loading = false;
          var pincodeList = successData.data;
          var newAreaListB = [];
          for (let i = 1; i <= pincodeList.length; i++) {
            if (pincodeList[i].D == pincodeVal) {
              this.f.city = pincodeList[i].B;
              this.f.state = pincodeList[i].F;
              newAreaListB.push(pincodeList[i].C);
              this.areaList = newAreaListB;
            }
          }

        }, errorData => {
          console.log("Oops..!! there is some error in Entered Poincode");
          this.loading = false;
          this.error = errorData.error.message;
          this.toasterService.showErrorToaster(this.error);
          if (errorData.error.status === 403) {
            this.error = errorData.error.message;
          }
        })
      } else {
        this.loading = false;
        this.toasterService.showErrorToaster("Invalid Pincode");
        return;
      }
    } else {
      this.loading = false;
      this.toasterService.showErrorToaster("Invalid Pincode");
      return;
    }
  }

  getGodigitPreviousInsurer() {
    this.loading = true;
    this.serviceURLService.getGodigitPreviousInsurer().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // console.log("successData Go Digit Previous Insurer ",successData);
      this.loading = false;
      this.previousInsurerData = successData.data
      // var pincodeList = successData
      //   var newAreaListA= [];
      // for(let i = 1;i <= this.previousInsurerData.length;i++){
      //   this.previousInsurerCode = this.previousInsurerData[i].Code;
      //   this.previousInsurerName = this.previousInsurerData[i].Name;
      // }
    }, errorData => {
      console.log("Oops..!! there is some error in Entered Poincode");
      this.loading = false;
      this.error = errorData.error.message;
      this.toasterService.showErrorToaster(this.error);
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  getSubInsurer(event) {
    this.f.subInsurance = event.target.value;
  }

  getSubInsuranceOnlead(event) {
    this.subInsuranceOnLead = event.target.value;
  }
  getSelectedPreviousInsurer(event) {
    this.f.previousInsurer = event.target.value;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
}
